import { CompanyLeaveStatus } from '@gokrew/models/leave-management';
import { Tone } from '@gokrew/models/ui.types';

export const STATUS_TONE: Record<CompanyLeaveStatus, Tone> = {
  [CompanyLeaveStatus.Pending]: Tone.WARNING,
  [CompanyLeaveStatus.Approved]: Tone.SUCCESS,
  [CompanyLeaveStatus.Rejected]: Tone.ERROR,
  [CompanyLeaveStatus.AutoApproved]: Tone.SUCCESS,
  [CompanyLeaveStatus.Cancelled]: Tone.NEUTRAL,
};

/** Leaf translation key per status — each host prefixes it with its own
 *  namespace path, so the mapping itself lives in one place. */
export const STATUS_LEAF: Record<CompanyLeaveStatus, string> = {
  [CompanyLeaveStatus.Pending]: 'pending',
  [CompanyLeaveStatus.Approved]: 'approved',
  [CompanyLeaveStatus.Rejected]: 'rejected',
  [CompanyLeaveStatus.AutoApproved]: 'auto_approved',
  [CompanyLeaveStatus.Cancelled]: 'cancelled',
};
